import axios from 'axios';
import type { ITourItem } from '@bb/domain/dist/types';

interface AddStopToTourResponse extends ITourItem {
  appointmentTourItemId: string;
  id: string;
}

const addStopToTour = async (
  tourId: string,
  stop: {
    address: string;
    locationName: string;
    // [Long, Lat]
    coordinates: [number, number];
  },
): Promise<AddStopToTourResponse> => {
  const { data } = await axios.post(`/tours/${tourId}/add_stop_to_tour`, {
    stop,
  });

  return data;
};

export default addStopToTour;
